import App from "@frog/source/models/App.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import World from "@frog/source/models/World.js"

import convertOldChapterScripting from "@frog/source/data/games/hero/convertOldChapterScripting.js"

export default {
    "slug": "upgrade-mercenary",
    "stage": {
        "image": require("./image.png"),
        "units": require("./units.json"),
        "world": World.parse({
            "encounters": require("./encounters.json"),
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "edges": {
                "3x0x1/0x+1": true
            }
        }),
        "text": function(stage) {
            return "Reach the castle."
        },
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    PlotSteps.SpawnPlayerPartyScript({"spotTag": "spawngood"}),
                    "brigid: ENTERS #position:4 #direction:left #expression:frowny",
                    "brigid: This is the place.",
                    "brigid: These attacks won't stop so long as they hold this castle.",
                    "oriana: ENTERS #position:1 #direction:left",
                    "oriana: Then we take the castle.",
                    "oriana: #direction:right #expression:happy",
                    "oriana: You got my back, yeah?",
                    "brigid: You know it! #expression:happy",
                ]
            },
            {
                "type": "turn:1:end",
                "events": [
                    PlotSteps.SpawnUnitAtSpot({
                        "spotTag": "spawnbadnorth",
                        "protounit": {
                            "affiliation": "bad",
                            "jobKey": "hero/rogue",
                        }
                    }),
                    "brigid: Watch out - enemies are flooding from the castle! #expression:frowny",
                ]
            },
            {
                "type": "turn:3:end",
                "events": [
                    PlotSteps.SpawnUnitAtSpot({
                        "spotTag": "spawnbadnorth",
                        "protounit": {
                            "affiliation": "bad",
                            "jobKey": "hero/archer",
                        }
                    })
                ]
            },
            {
                "type": "turn:5:end",
                "events": [
                    PlotSteps.SpawnUnitAtSpot({
                        "spotTag": "spawnbadnorth",
                        "protounit": {
                            "affiliation": "bad",
                            "jobKey": "hero/rogue",
                        }
                    })
                ]
            },
            {
                "type": "turn:7:end",
                "events": [
                    PlotSteps.SpawnUnitAtSpot({
                        "spotTag": "spawnbadsouth",
                        "protounit": {
                            "affiliation": "bad",
                            "jobKey": "hero/berserker",
                        }
                    })
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return PlotConditions.hasReachedSpot(stage, {"spotTag": "victory"})
                },
                "events": [
                    PlotSteps.ChapterSuccess(),
                    {"func": () => Navigation.go("/games/hero/overworld")},
                    {"func": () => App.game.overworld.locations["C"].isFinished = Date.now()}
                ]
            },
            PlotScripts.ChapterFailure(),
        ]
    },
}

// // https://serenesforest.net/wp-content/uploads/2017/02/15.png
// "upgrade-mercenary": {
//     "music": "hero-alt",
//     "hasPreparation": false,
//     "map": {
//         "width": 6,
//         "height": 8,
//         "image": require("@frog/source/assets/images/hero-tactics/stages/moat.png"),
//         "tiles": [
//             {"position": {"x": 1, "y": 1}, "passable": false},
//             {"position": {"x": 2, "y": 1}, "passable": false},
//             {"position": {"x": 3, "y": 1}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/fort_red.png")},
//             {"position": {"x": 1, "y": 3}, "passable": false},
//             {"position": {"x": 1, "y": 4}, "passable": false},
//             {"position": {"x": 2, "y": 4}, "passable": false},
//             {"position": {"x": 4, "y": 1}, "passable": false},
//             {"position": {"x": 4, "y": 2}, "passable": false},
//             {"position": {"x": 4, "y": 3}, "passable": false},
//             {"position": {"x": 4, "y": 4}, "passable": false},
//             {"position": {"x": 4, "y": 5}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_2.png")},
//             {"position": {"x": 2, "y": 6}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/house.png")},
//             {"position": {"x": 1, "y": 7}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/house.png")},
//             {"position": {"x": 1, "y": 6}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             // {"position": {x: 4, y: 5}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             // {"position": {x: 2, y: 5}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             // {"position": {x: 1, y: 5}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             // {"position": {x: 2, y: 7}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             // {"position": {x: 0, y: 0}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//             // {"position": {x: 0, y: 7}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_2.png")},
//             // {"position": {x: 5, y: 7}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_2.png")},
//             // {"position": {x: 3, y: 7}, "passable": false, "image": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png")},
//         ]
//     },
//     "spawns": [
//         {"position": {"x": 5, "y": 1}, "affiliation": "good"},
//         {"position": {"x": 5, "y": 0}, "affiliation": "good"},
//         {"position": {"x": 4, "y": 0}, "affiliation": "good"},
//         {"position": {"x": 0, "y": 1}, "affiliation": "bad", "classKey": "berserker"},
//         {"position": {"x": 3, "y": 2}, "affiliation": "bad", "classKey": "archer"},
//         {"position": {"x": 2, "y": 3}, "affiliation": "bad", "classKey": "archer"},
//         {"position": {"x": 4, "y": 6}, "affiliation": "bad", "classKey": "berserker"},
//     ],
//     "events": {
//         "5:end": [
//             {
//                 "type": "SpawnUnit",
//                 "spawn": {
//                     "key": "#1",
//                     "position": {"x": 2, "y": 8},
//                     "classKey": "berserker",
//                     "affiliation": "bad",
//                 },
//             },
//             {
//                 "type": "MoveUnit",
//                 "position": {"x": 2, "y": 7},
//                 "classKey": "#1",
//             }
//         ],
//     },
//     "afterVictory": [
//         {"type": "TransitionScreen", "screen": "/games/hero/overworld"},
//         {"type": "FinishLocation", "locationKey": "C"},
//     ],
//     "nextUrl": "/games/hero/chapters/introduce-cleric",
// },
